import React from 'react'
import $ from 'jquery'
import classnames from 'classnames'
import Transition from 'react-transition-group/Transition'
import pick from 'lodash/pick'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import throttle from 'lodash/throttle'
import clamp from 'lodash/clamp'
import findIndex from 'lodash/findIndex'

import marked from 'marked'

import { TweenMax, Back, Sine, Elastic } from 'gsap'
import 'gsap/CSSPlugin'

import Carousel from '../components/carousel'
import Layout from '../components/layout'
import CardCarousel from '../components/card-carousel'
import TimelineVideo from '../components/timeline-video'
import TimelineScrubBgDefault from '../components/timeline-scrub-bg'
import TimelineScrubBgFallback from '../components/timeline-scrub-bg-fallback'

import p1 from '../markers_crop/p1.png'
import p2 from '../markers_crop/p2.png'
import p3 from '../markers_crop/p3.png'
import p4 from '../markers_crop/p4.png'
import p5 from '../markers_crop/p5.png'
import p6 from '../markers_crop/p6.png'
import p7 from '../markers_crop/p7.png'
import p8 from '../markers_crop/p8.png'

import HeroBg from '../components/images/explore-hero'

import contentfulClient from '../util/contentful-client'

const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : ''
const IS_IE = !!userAgent.match(/Trident/g) || !!userAgent.match(/MSIE/g)
const USE_BG_FALLBACK = IS_IE

const TimelineScrubBg = USE_BG_FALLBACK
  ? TimelineScrubBgFallback
  : TimelineScrubBgDefault

const pins = [p1, p2, p3, p4, p5, p6, p7, p8]

const years = [
  '1860',
  '1871',
  '1880',
  '1890',
  '1900',
  '1910',
  '1920',
  '1930',
  '1940',
  '1950',
  '1960',
  '1970',
  '1980',
  '1990',
  '2000',
  '2016',
]

var imageWidth = 1920
var imageHeight = 1080
var aspectRatio = imageWidth / imageHeight

export default class IndexPage extends React.Component {
  state = {
    startExplore: false,
    touchedTimeline: false,
    index: years.indexOf('1860'),
    showCardCarousel: false,
    hotspots: [],
    videoPlaying: false,
    cardSliderRef: React.createRef(),
    loadProgress: 0,
    headline: '',
    body: '',
    offset: {
      clicked: null,
      dragStart: null,
      dragOffset: 0,
    },
    mounted: false,
  }

  componentDidMount() {
    this.setState({ mounted: true })

    contentfulClient
      .getEntries({
        content_type: 'history',
        limit: 500,
      })
      .then((entries) => {
        const hotspots = orderBy(
          entries.items.map(({ fields, sys }) => ({
            id: sys.id,
            hide_pin: !!fields.hide_pin,
            content: marked(fields.body || ''),
            name: fields.headline,
            mediaSrc: get(fields, 'image.fields.file.url'),
            width: get(fields, 'image.fields.file.details.image.width'),
            height: get(fields, 'image.fields.file.details.image.height'),
            isVideo:
              get(fields, 'image.fields.file.contentType', '').indexOf(
                'video'
              ) > -1,
            is360Image: !!fields.is_360_image,
            ...pick(fields, ['p', 'x', 'y', 'w', 'h', 'year']),
          })),
          ['year', 'name', 'hide_pin'],
          ['asc', 'asc', 'desc']
        )

        const hotspotsPre2020 = hotspots.filter(h => h.year !== '2020');

        this.setState(
          {
            hotspots: hotspotsPre2020,
          },
          () => {
            this.positionHotspots()
          }
        )
      })

    contentfulClient
      .getEntries({
        content_type: 'intro_page',
      })
      .then((entries) => {
        const entry = entries.items[0]
        const { headline, body } = entry.fields
        this.setState({ headline, body })
      })
  }

  get loadingDone() {
    return this.state.loadProgress === 100
  }

  setOffset = (offset) => {
    this.setState({
      offset: {
        ...this.state.offset,
        ...offset,
      },
    })
  }

  startExploring = () => {
    this.setState({ startExplore: true })

    $(window).resize(this.positionHotspots)
  }

  handleChange = (index) => {
    this.setState({ index, touchedTimeline: true })
    this.startIdleLoop()
  }

  handleLoadProgress = (loadProgress) => {
    this.setState({ loadProgress })
  }

  getLimits(t) {
    var tl = document.querySelector('.timeline')

    return {
      left: tl.position().left + t.position().left,
      right: tl.position().left + (t.position().left + t.width()),
      inLeft: t.position().left,
    }
  }

  startIdleLoop = () => {
    const currentYear = years[this.state.index].trim().substr(0, 3) + '0'

    TweenMax.to($('.hotspot'), 0, {
      ease: Sine.easeIn,
      scale: 0,
      onComplete: function () {
        $('.hotspot').hide()
        $('.hs_' + currentYear).show()
      },
    })

    TweenMax.to($('.hs_' + currentYear), 1.3, {
      ease: Elastic.easeOut.config(1, 0.4),
      scale: 1,
      delay: 0.23 + $(this.target).attr('slide-index'),
    })
  }

  _positionHotspots = () => {
    const self = this
    $('.hotspot').remove()

    var wi = 0,
      hi = 0
    var r = $(window).width() / $(window).height()

    if (aspectRatio <= r) {
      wi = $(window).width()
      hi = $(window).width() / aspectRatio
    } else {
      wi = $(window).height() * aspectRatio
      hi = $(window).height()
    }

    var offsetTop = (hi - $(window).height()) / 2
    var offsetLeft = (wi - $(window).width()) / 2

    this.state.hotspots.forEach((h, i) => {
      var decade = String(h.year).substr(0, 3) + '0'

      if (h.hide_pin) return

      var x = (wi * h.x) / imageWidth
      var y = (hi * h.y) / imageHeight

      var ww = (wi * 150) / imageWidth
      var hh = (hi * 150) / imageHeight

      var hotspot = $(
        '<a href="" id="jh_marker_' +
          i +
          '"  data-index="' +
          h.year +
          '" data-index="' +
          i +
          '" slide-index="' +
          i +
          '">'
      )
        .addClass('hotspot')
        .addClass('hs_' + decade)
        .css({
          top: y - offsetTop,
          left: x - offsetLeft,
          height: hh,
          width: ww,
        })

      var pin = pins[h.p - 1]
      var hs_sign = $(
        "<div class='hs-sign shadow' style='width: 0px; padding: 0px;'><h4 class='hs-title' style='opacity: 0;'>" +
          h.name +
          '</h4></div>'
      )
      var hs_img = $(
        `<img class='hs-img' alt='Pin - Centralstationsområdet Jernhusen' src='${pin}' width='100%'>`
      )

      $('#explore').append(hotspot)
      hotspot.append(hs_sign)
      hotspot.append(hs_img)

      $('#jh_marker_' + i).bind('mouseenter focus', function () {
        $(this).css('z-index', '999')

        if ($(this).position().left < $(window).width() / 2) {
          TweenMax.set($(this).find('.hs-sign'), {
            left: '48%',
            paddingLeft: '30px',
            paddingRight: '10px',
          })
        } else {
          TweenMax.set($(this).find('.hs-sign'), {
            right: '52%',
            paddingRight: '30px',
            paddingLeft: '10px',
          })
        }

        TweenMax.to($(this).find('.hs-sign'), 0.25, {
          ease: Back.easeOut,
          width: h.w + '%',
          height: '50px',
        })
        TweenMax.to($(this).find('.hs-sign').find('h4'), 0.25, {
          ease: Sine.easeInOut,
          opacity: 1,
          delay: 0,
        })
      })

      $('#jh_marker_' + i).bind('mouseleave blur', function () {
        $(this).css('z-index', '1')
        TweenMax.to($(this).find('.hs-sign'), 0.25, {
          ease: Sine.easeIn,
          width: '0px',
          padding: '0px',
          height: '50px',
          delay: 0.1,
        })
        TweenMax.to($(this).find('.hs-sign').find('h4'), 0.1, {
          ease: Sine.easeInOut,
          opacity: 0,
        })
      })

      $('#jh_marker_' + i).click(function (e) {
        e.preventDefault()

        var initIndex = $(this).attr('slide-index')
        self.openCardCarousel(initIndex)
      })
    })

    this.startIdleLoop()
  }

  positionHotspots = throttle(this._positionHotspots, 100)

  setDecade = (cardYear) => {
    if (!cardYear) return
    const cardDecade = cardYear.slice(0, 3)
    const currentDecade = years[this.state.index].slice(0, 3)

    if (currentDecade === cardDecade) return

    const cardYearIndex = findIndex(years, (y) => y.slice(0, 3) === cardDecade)
    if (cardYearIndex > -1) {
      this.setState({ index: cardYearIndex }, this.startIdleLoop)
    }
  }

  openCurrentDecade = () => {
    const decade = years[this.state.index].trim().slice(0, 3)

    const index =
      findIndex(this.state.hotspots, (h) => h.year.slice(0, 3) === decade) || 0

    this.openCardCarousel(index)
  }

  openCardCarousel = (index = 0) => {
    this.state.cardSliderRef.current.slickGoTo(index, true)

    $('.slider-container').fadeIn()

    this.setState({ showCardCarousel: true })
  }

  closeCardCarousel = () => {
    $('.slider-container').fadeOut()

    this.setState({ showCardCarousel: false })
  }

  get infoClass() {
    return classnames({
      'timeline-info text-center': true,
      'fade-out': this.state.touchedTimeline,
    })
  }

  get exploreClass() {
    return classnames({
      explore: true,
      'fade-in': this.state.startExplore && this.loadingDone,
    })
  }

  get scrubFrameId() {
    let index = this.state.index - this.state.offset.dragOffset

    if (index < 1) index = (index - 0) * 30
    else if (index < 2) index = 30
    else index = (index - 1) * 30

    return clamp(Math.round(index), 0, 419)
  }

  render() {
    return (
      <Layout {...this.props}>
        <Transition
          in={!this.state.startExplore || !this.loadingDone}
          timeout={500}
          unmountOnExit
        >
          {(status) => (
            <div
              className={classnames({
                'intro-container': true,
                'fade-out': status === 'exiting',
              })}
            >
              <div className="grid-center text-center intro">
                <div className="intro-info">
                  {/* <h1 className="intro-headline is-white">{this.state.headline}</h1>
                  <p className="intro-body is-white">{this.state.body}</p> */}
                  <button
                    type="button"
                    className="button button-rounded button-primary"
                    onClick={this.startExploring}
                  >
                    {this.state.startExplore
                      ? `Laddar ${Math.round(this.state.loadProgress)}%`
                      : 'Ladda historien'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </Transition>
        <HeroBg className="hero" style={{ position: 'fixed' }} />
        {this.state.startExplore && this.loadingDone && (
          <TimelineVideo
            year={years[this.state.index]}
            onPlaying={(videoPlaying) => this.setState({ videoPlaying })}
            hide={this.state.offset.dragStart != null}
          />
        )}
        {this.state.mounted && (
          <TimelineScrubBg
            is2020={false}
            frameId={this.scrubFrameId}
            handleProgress={this.handleLoadProgress}
            handle2020Progress={this.handleLoadProgress}
            hide={
              (this.state.videoPlaying || this.state.index === 0) &&
              this.state.offset.dragStart == null
            }
          />
        )}
        <div id="explore" className={this.exploreClass}>
          <Carousel
            controlledOffset={this.state.offset}
            setOffset={this.setOffset}
            className="timeline-handle"
            value={this.state.index}
            onChange={this.handleChange}
            onClickedCurrent={this.openCurrentDecade}
            infinite={false}
            centered
            animationSpeed={500}
            slidesPerPage={1}
            slidesToScroll={1}
            keepDirectionWhenDragging
          >
            {years.map((year) => (
              <div key={year} className="timeline-cell">
                <div className="timeline-inner">
                  <h3 className="timeline-decade">{year}</h3>
                </div>
              </div>
            ))}
          </Carousel>
          <div className={this.infoClass}>
            <p className="timeline-text">
              Dra horisontellt för att
              <br />
              utforska utvecklingen
            </p>
          </div>
          <Carousel
            controlledOffset={this.state.offset}
            setOffset={this.setOffset}
            className="timeline"
            value={this.state.index}
            onChange={this.handleChange}
            infinite={false}
            centered
            clickToChange
            animationSpeed={500}
            slidesPerPage={21}
            slidesToScroll={1}
            keepDirectionWhenDragging
            breakpoints={{
              1700: {
                slidesPerPage: 17,
              },
              1500: {
                slidesPerPage: 14,
              },
              1300: {
                slidesPerPage: 12,
              },
              1024: {
                slidesPerPage: 8,
              },
              680: {
                slidesPerPage: 6,
              },
              575: {
                slidesPerPage: 5,
              },
              440: {
                slidesPerPage: 4,
              },
            }}
          >
            {years.map((year) => (
              <div key={year} id={year} className="timeline-slide">
                <div className="decade-line"></div>
                <button type="button" className="decade-ring"></button>
                <div className="decade-line"></div>
                <div className="decade-label timeline-text">{year}</div>
              </div>
            ))}
          </Carousel>
        </div>
        {this.loadingDone && (
          <CardCarousel
            sliderRef={this.state.cardSliderRef}
            setDecade={this.setDecade}
            isOpen={this.state.showCardCarousel}
            onPressClose={this.closeCardCarousel}
            hotspots={this.state.hotspots}
          />
        )}
      </Layout>
    )
  }
}
